import { OptimizelyContext, useFeature } from '@optimizely/react-sdk'
import { useContext } from 'react'

// not exported by sdk
interface VariableValuesObject {
  [key: string]: boolean | number | string | null
}

export interface UseOptimizelyFeature {
  isEnabled: boolean
  variables: VariableValuesObject
  clientReady: boolean
  didTimeout: boolean
}

export const useOptimizelyFeature = (featureKey: string): UseOptimizelyFeature => {
  const { optimizely } = useContext(OptimizelyContext)

  // return early is ok here due to optimizely either existing or not, as it will not change
  if (!optimizely) {
    return {
      isEnabled: false,
      variables: {},
      clientReady: true,
      didTimeout: false,
    }
  }
  // eslint-disable-next-line
  const [isEnabled, variables, clientReady, didTimeout] = useFeature(featureKey)
  return {
    isEnabled,
    variables,
    clientReady,
    didTimeout,
  }
}



// WEBPACK FOOTER //
// ./src/utils/hooks/useOptimizelyFeature.tsx